import React, { useEffect, useState } from "react";
import { getEmailReceipts } from "../../utils/firebasefunctions";
import { useStateValue } from "../../context/StateProvider";
import moment from "moment";
import MailDetailPopup from "./email-log-detail";

const EmailLog = () => {
  const [{ user }, dispatch] = useStateValue();
  const [activeTab, setActiveTab] = useState("all");
  const [emailLogs, setEmailLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isEmailDetail, setIsEmailDetail] = useState(false);
  const [isEmailData, setIsEmailData] = useState('');

  const tabs = [
    { id: "all", label: "All" },
    { id: "recaps", label: "Recaps" },
    { id: "scheduling", label: "Scheduling" },
    { id: "cancellations", label: "Cancellations" },
    { id: "staging", label: "Staging Vendor" },
    { id: "destaging", label: "Destaging Vendor" },
  ];

  // Fetch data function
  const loadEmailLogs = async () => {
    try {
      setLoading(true);

      if (!user) {
        console.log("No logged in user");
        return;
      }

      const data = await getEmailReceipts(user.id, activeTab);
      console.log("data", data);
      setEmailLogs(data);
    } catch (error) {
      console.error("Error loading logs:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenPopup = (data) => {
    setIsEmailData(data)
    setIsEmailDetail(true);
  }

  // Initial load + tab switch
  useEffect(() => {
    loadEmailLogs();
  }, [activeTab]);

  return (
    <div>
      {/* Tabs */}
      <div className="flex overflow-x-auto panelScroll gap-3 mb-4">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center text-[13px] font-medium justify-center gap-2 whitespace-nowrap px-3 sm:px-2.5 py-1 rounded-lg flex-shrink-0 transition-all ${
              activeTab === tab.id
                ? "bg-gradient-to-b from-[#0f172a] to-[#1E293B] text-white"
                : "bg-white text-gray-500 hover:bg-blue-50"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Table Section */}
      <div className="overflow-x-auto panelScroll bg-white px-2 rounded-2xl border border-gray-200 shadow-sm">
        <h3 className="text-lg font-semibold pl-4 mt-4 mb-2">
          Emails Log
        </h3>
        {loading ? (
          <div role="status" className="flex justify-center mb-5">
            <svg
              aria-hidden="true"
              class="size-14 text-gray-200 animate-spin dark:text-white fill-themeColor"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span class="sr-only">Loading...</span>
          </div>
        ) : emailLogs.length === 0 ? (
          <p className="text-center py-10 text-gray-500">No records found</p>
        ) : (
          <table className="min-w-[700px] w-full">
            <thead>
              <tr className="bg-gray-50">
                <th className="w-full md:w-[10%] pl-4 py-3 text-left text-gray-500 uppercase text-xs tracking-wider font-semibold">Sent</th>
                <th className="w-full md:w-[10%] py-3 text-center text-gray-500 uppercase text-xs tracking-wider font-semibold">Type</th>
                <th className="w-full md:w-[20%] py-3 text-center text-gray-500 uppercase text-xs tracking-wider font-semibold">To</th>
                <th className="w-full md:w-[25%] py-3 text-center text-gray-500 uppercase text-xs tracking-wider font-semibold">Subject</th>
                <th className="w-full md:w-[10%] py-3 text-center text-gray-500 uppercase text-xs font-semibold tracking-wider">Status</th>
                <th className="w-full md:w-[15%] py-3 text-center text-gray-500 uppercase text-xs tracking-wider font-semibold">Sent By</th>
                <th className="w-full md:w-[10%] py-3 text-center text-gray-500 uppercase text-xs tracking-wider font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody>
              {emailLogs.map((log) => (
                <tr
                  key={log.id}
                  className="border-b border-gray-200 hover:bg-gray-50"
                >
                  <td className="px-4 py-3 text-center whitespace-nowrap text-sm">
                    {moment(log.id).format("MM/DD/YYYY")}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <div
                      className={`capitalize font-medium rounded-lg text-[13px] px-2 py-1 ${log.type === "staging" ? "bg-slate-50 text-linkColor" : "bg-red-50 text-red-600"}`}
                    >
                      {log.type}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-center">
                    <div>
                      <p className="font-semibold capitalize text-sm">
                        {log.receivername}
                      </p>
                      <p className="text-[13px] text-gray-600">{log.to}</p>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-center whitespace-nowrap xl:whitespace-normal text-sm">{log.subject}</td>
                  <td className="px-4 py-3 text-center">
                    <div className="flex items-center justify-center gap-x-2 px-1 py-1 text-[13px] font-medium bg-green-50 rounded-xl text-green-600">
                      <div className="bg-green-600 size-2 rounded-full"></div>
                      Sent
                    </div>
                  </td>
                  <td className="px-4 py-3 text-center capitalize whitespace-nowrap lg:whitespace-normal text-sm">
                    {user.firstname} {user.lastname}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <button onClick={() => handleOpenPopup(log)} className="font-semibold border text-[13px] border-gray-400 rounded-lg px-2 py-1">
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      { isEmailDetail &&
        <MailDetailPopup mailData={isEmailData} onClose={() => setIsEmailDetail(false)}/>
      }
    </div>
  );
};

export default EmailLog;
